import { PORTAL_ROUTE } from '../../constants/routes';

export const initialTabs = [
  {
    label: 'Company Users',
    value: `${PORTAL_ROUTE}/company/members`,
  },
  {
    label: 'Environments',
    value: `${PORTAL_ROUTE}/company/environments`,
  },
];
